"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const debug_provider_1 = __importDefault(require("../components/debug/debug-provider"));
const page_debug_1 = __importDefault(require("../components/debug/page-debug"));
const language_provider_1 = __importDefault(require("../components/language/language-provider"));
const global_seo_1 = __importDefault(require("../components/global-seo"));
const gatsby_query_store_1 = require("./gatsby-query-store");
const use_user_1 = __importDefault(require("../components/user/use-user"));
const gatsby_plugin_image_1 = require("gatsby-plugin-image");
const reach_router_1 = require("@gatsbyjs/reach-router");
const json_ld_1 = __importDefault(require("../components/json-ld"));
const Layout = (props) => {
    const { children, location, pageContext, globalData } = props;
    const { authenticated, loading } = (0, use_user_1.default)();
    if (!globalData) {
        throw new Error("globalData is required on AtollonProvider.");
    }
    const { maybeRequiresLogin } = pageContext;
    // need also head content in here
    if ((maybeRequiresLogin && loading) || (maybeRequiresLogin && !loading && !authenticated)) {
        if (maybeRequiresLogin && !loading && !authenticated) {
            // do navigation event
            const link = globalData?.datoCmsUserSetting?.defaultLoginPage?.[0]?.internalLink?.permalink;
            if (link) {
                (0, reach_router_1.navigate)(`${link}/`);
            }
            else if (props.location.pathname !== "/") {
                (0, reach_router_1.navigate)("/");
            }
        }
        return react_1.default.createElement("div", { style: {
                backgroundColor: `rgb(${globalData.siteCfg.theme.accentColor.red}, ${globalData.siteCfg.theme.accentColor.green}, ${globalData.siteCfg.theme.accentColor.blue})`,
                color: `rgb(${globalData.siteCfg.theme.lightColor.red}, ${globalData.siteCfg.theme.lightColor.green}, ${globalData.siteCfg.theme.lightColor.blue})`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                height: '100vh',
                width: '100%',
                position: 'fixed',
            } },
            react_1.default.createElement("style", { type: "text/css", id: "atl-asset", dangerouslySetInnerHTML: {
                    __html: `
                   @keyframes atl-spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                   }
                   .atl-spinner {
                        width: 1.5rem;
                        height: 1.5rem;
                        display: inline-block;
                        animation: atl-spin 0.45s linear infinite;
                        border-color: currentColor;
                        border-style: solid;
                        border-width: 2px;
                        border-radius: 99999px;
                        border-left-color: transparent;
                        border-bottom-color: transparent;
                   }
                `
                } }),
            globalData.siteImg?.gatsbyImageData && (react_1.default.createElement(gatsby_plugin_image_1.GatsbyImage, { alt: globalData.siteCfg.name, style: { width: '80px', marginBottom: '48px' }, image: globalData.siteImg?.gatsbyImageData })),
            (globalData.siteImg?.url && !globalData.siteImg?.gatsbyImageData) && (react_1.default.createElement("img", { alt: globalData.siteCfg.name, style: { width: '80px', marginBottom: '48px' }, src: globalData.siteImg?.url })),
            react_1.default.createElement("div", { style: { color: `rgb(${globalData.siteCfg.theme.lightColor.red}, ${globalData.siteCfg.theme.lightColor.green}, ${globalData.siteCfg.theme.lightColor.blue})`, }, className: "atl-spinner" }));
    }
    return (react_1.default.createElement(gatsby_query_store_1.GatsbyQueryStore, { data: globalData },
        react_1.default.createElement(json_ld_1.default, { ...props }),
        react_1.default.createElement("style", { type: "text/css", id: "atl-asset", dangerouslySetInnerHTML: {
                __html: `
                   .atl-asset {
                        position: relative;
                    }
                    .atl-asset video {
                        object-fit: var(--object-fit);
                        object-position: var(--object-position);
                    }
                    .atl-asset .play {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        opacity: 0;
                        transition: opacity 0.3s;
                    }
                    .atl-asset[data-playing="false"] .play {
                        opacity: 1;
                    } 
                `
            } }),
        react_1.default.createElement(debug_provider_1.default, { id: (props?.pageContext).originalId },
            react_1.default.createElement(page_debug_1.default, { ...props }),
            react_1.default.createElement(language_provider_1.default, { ...props },
                react_1.default.createElement(global_seo_1.default, { ...props }),
                children))));
};
exports.default = Layout;
//# sourceMappingURL=index.js.map